export enum CanvasAgentTemplateEnum {
    MEDIA_COVERAGE_BRIEFING,
    COMPARISON_BRIEFING,
    QUARTERLY_COVERAGE_BRIEFING,
    MONTHLY_COVERAGE_BRIEFING
}
